import { z } from 'zod';

export const PostTopicSchema = z.object({
  id: z.string().guid(),
  postId: z.string().guid(),
  title: z.string(),
  angle: z.string().nullable(),
  isSelected: z.boolean(),
  generatedBy: z.enum(['ai', 'manual', 'ai_edited']),
  aiTaskId: z.string().guid().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type PostTopic = z.infer<typeof PostTopicSchema>;

export const CreatePostTopicSchema = z.object({
  title: z.string().min(2).max(280),
  angle: z.string().max(2000).optional(),
  setSelected: z.boolean().default(true),
});
export type CreatePostTopic = z.infer<typeof CreatePostTopicSchema>;

export const UpdatePostTopicSchema = z.object({
  title: z.string().min(2).max(280).optional(),
  angle: z.string().max(2000).nullable().optional(),
});
export type UpdatePostTopic = z.infer<typeof UpdatePostTopicSchema>;
